/* Simple rectangular tray v1. Coordinates are millimetres; STL has no unit metadata. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SKTrayGeometry = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const version = 'tray-v1';
  function validate(width, depth, height) {
    return Number.isInteger(width) && width >= 20 && width <= 300 &&
      Number.isInteger(depth) && depth >= 20 && depth <= 300 &&
      Number.isInteger(height) && height >= 8 && height <= 150;
  }
  function create(width, depth, height) {
    if (!validate(width, depth, height)) throw new RangeError('寸法を入力範囲内の整数にしてください。');
    const thickness = 2, triangles = [];
    const xs = [0, thickness, width - thickness, width];
    const ys = [0, thickness, depth - thickness, depth];
    const zs = [0, thickness, height];
    const full = (i, j, k) => i >= 0 && i < 3 && j >= 0 && j < 3 && k >= 0 && k < 2 &&
      (k === 0 || i === 0 || i === 2 || j === 0 || j === 2);
    const quad = (v) => { triangles.push([v[0], v[1], v[2]], [v[0], v[2], v[3]]); };
    for (let i = 0; i < 3; i++) for (let j = 0; j < 3; j++) for (let k = 0; k < 2; k++) {
      if (!full(i, j, k)) continue;
      const a = xs[i], b = xs[i + 1], c = ys[j], d = ys[j + 1], e = zs[k], f = zs[k + 1];
      if (!full(i - 1, j, k)) quad([[a,c,e],[a,c,f],[a,d,f],[a,d,e]]);
      if (!full(i + 1, j, k)) quad([[b,c,e],[b,d,e],[b,d,f],[b,c,f]]);
      if (!full(i, j - 1, k)) quad([[a,c,e],[b,c,e],[b,c,f],[a,c,f]]);
      if (!full(i, j + 1, k)) quad([[a,d,e],[a,d,f],[b,d,f],[b,d,e]]);
      if (!full(i, j, k - 1)) quad([[a,c,e],[a,d,e],[b,d,e],[b,c,e]]);
      if (!full(i, j, k + 1)) quad([[a,c,f],[b,c,f],[b,d,f],[a,d,f]]);
    }
    return { version, width, depth, height, thickness, triangles };
  }
  function normal(triangle) {
    const [a,b,c] = triangle, u = b.map((v,i) => v-a[i]), v = c.map((n,i) => n-a[i]);
    const n = [u[1]*v[2]-u[2]*v[1],u[2]*v[0]-u[0]*v[2],u[0]*v[1]-u[1]*v[0]];
    const length = Math.hypot(...n);
    return n.map((value) => value / length);
  }
  function toSTL(mesh) {
    const buffer = new ArrayBuffer(84 + 50 * mesh.triangles.length), view = new DataView(buffer);
    const header = 'SK Honpo ' + version + ' | coordinates in mm';
    for (let i = 0; i < header.length; i++) view.setUint8(i, header.charCodeAt(i));
    view.setUint32(80, mesh.triangles.length, true);
    let offset = 84;
    for (const triangle of mesh.triangles) {
      for (const point of [normal(triangle), ...triangle]) for (const value of point) {
        view.setFloat32(offset, value, true); offset += 4;
      }
      view.setUint16(offset, 0, true); offset += 2;
    }
    return buffer;
  }
  return { version, validate, create, normal, toSTL };
});
